import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";

export default function UsersTableHeader({ searchValue = "", onSearchChange }) {
  return (
    <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 justify-between">
      <div className="relative flex-1 max-w-sm">
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-4 w-4" />
        <Input
          placeholder="Search users..."
          value={searchValue}
          onChange={(e) => onSearchChange?.(e.target.value)}
          className="pl-10"
        />
      </div>
    </div>
  );
}
